import { useCallback } from 'react';
import { AppModal } from '@/components/compose/app.modal';
import styled, { useTheme } from 'styled-components/native';
import { AppTextView } from '@/components/base/app.text.view';
import { AppIconButton } from '@/components/base/app.icon.button';
import { Box } from '@/components/base/box';
import { useNavigation } from '@react-navigation/native';
import { getModalCallback } from '@/navigation/modal.callbacks';
import { AppPressable } from '@/components/base/app.pressable';
import { Platform } from 'react-native';

export default function FilePickerModal() {
  const navigation = useNavigation();
  const theme = useTheme();
  const onOptionSelected = getModalCallback('filePicker:onOptionSelected');

  const handleOption = useCallback(
    (option: 'gallery' | 'camera' | 'pdf' | 'video' | 'file') => {
      navigation.goBack();
      onOptionSelected(option);
    },
    [onOptionSelected, navigation],
  );

  return (
    <AppModal title={'انتخاب فایل'}>
      <Row onPress={() => handleOption('gallery')}>
        <AppTextView text={'گالری'} variant={'medium'} textColor={'grey_light'} />
        <Icon icon={'gallery'} color={theme.colors.icon.jade_dark} />
      </Row>
      <Line />
      <Row onPress={() => handleOption('camera')}>
        <AppTextView text={'دوربین'} variant={'medium'} textColor={'grey_light'} />
        <Icon icon={'camera'} color={theme.colors.icon.jade_dark} />
      </Row>
      <Line />
      <Row onPress={() => handleOption('video')}>
        <AppTextView text={'ویدئو'} variant={'medium'} textColor={'grey_light'} />
        <Icon icon={'video'} color={theme.colors.icon.jade_dark} />
      </Row>
      <Line />
      <Row onPress={() => handleOption('pdf')}>
        <AppTextView text={'پی دی اف'} variant={'medium'} textColor={'grey_light'} />
        <Icon icon={'pdf'} color={theme.colors.icon.jade_dark} />
      </Row>
      <Line />
      {Platform.OS === 'web' && (
        <Row onPress={() => handleOption('file')}>
          <AppTextView text={'فایل'} variant={'medium'} textColor={'grey_light'} />
          <Icon icon={'pdf'} color={theme.colors.icon.jade_dark} />
        </Row>
      )}
    </AppModal>
  );
}

const Icon = styled(AppIconButton)`
  margin-left: 20px;
`;

const Row = styled(AppPressable)`
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
`;

const Line = styled(Box)`
  background-color: ${({ theme }) => theme.colors.greyWhite};
  height: 1px;
  width: 100%;
  margin-vertical: 10px;
`;
